module.exports = __webpack_public_path__ + "images/icon_debug_wca_908ee21e33ac1e828af7d95c5aeb438f.svg";